export enum NationalityEnum {
  'Afghan' = 'Afghan',
  'Albanian' = 'Albanian',
  'Algerian' = 'Algerian',
  'American' = 'American',
  'Andorran' = 'Andorran',
  'Angolan' = 'Angolan',
  'Anguillan' = 'Anguillan',
  'Argentine' = 'Argentine',
  'Armenian' = 'Armenian',
  'Australian' = 'Australian',
  'Austrian' = 'Austrian',
  'Azerbaijani' = 'Azerbaijani',
  'Bahamian' = 'Bahamian',
  'Bahraini' = 'Bahraini',
  'Bangladeshi' = 'Bangladeshi',
  'Barbadian' = 'Barbadian',
  'Belarusian' = 'Belarusian',
  'Belgian' = 'Belgian',
  'Belizean' = 'Belizean',
  'Beninese' = 'Beninese',
  'Bermudian' = 'Bermudian',
  'Bhutanese' = 'Bhutanese',
  'Bolivian' = 'Bolivian',
  'Botswanan' = 'Botswanan',
  'Brazilian' = 'Brazilian',
  'British' = 'British',
  'British Virgin Islander' = 'British Virgin Islander',
  'Bruneian' = 'Bruneian',
  'Bulgarian' = 'Bulgarian',
  'Burkinan' = 'Burkinan',
  'Burmese' = 'Burmese',
  'Burundian' = 'Burundian',
  'Cambodian' = 'Cambodian',
  'Cameroonian' = 'Cameroonian',
  'Canadian' = 'Canadian',
  'Cape Verdean' = 'Cape Verdean',
  'Cayman Islander' = 'Cayman Islander',
  'Central African' = 'Central African',
  'Chadian' = 'Chadian',
  'Chilean' = 'Chilean',
  'Chinese' = 'Chinese',
  'Citizen of Antigua and Barbuda' = 'Citizen of Antigua and Barbuda',
  'Citizen of Bosnia and Herzegovina' = 'Citizen of Bosnia and Herzegovina',
  'Citizen of Guinea-Bissau' = 'Citizen of Guinea-Bissau',
  'Citizen of Kiribati' = 'Citizen of Kiribati',
  'Citizen of Seychelles' = 'Citizen of Seychelles',
  'Citizen of the Dominican Republic' = 'Citizen of the Dominican Republic',
  'Citizen of Vanuatu' = 'Citizen of Vanuatu',
  'Colombian' = 'Colombian',
  'Comoran' = 'Comoran',
  'Congolese (Congo)' = 'Congolese (Congo)',
  'Congolese (DRC)' = 'Congolese (DRC)',
  'Cook Islander' = 'Cook Islander',
  'Costa Rican' = 'Costa Rican',
  'Croatian' = 'Croatian',
  'Cuban' = 'Cuban',
  'Cymraes' = 'Cymraes',
  'Cymro' = 'Cymro',
  'Cypriot' = 'Cypriot',
  'Czech' = 'Czech',
  'Danish' = 'Danish',
  'Djiboutian' = 'Djiboutian',
  'Dominican' = 'Dominican',
  'Dutch' = 'Dutch',
  'East Timorese' = 'East Timorese',
  'Ecuadorean' = 'Ecuadorean',
  'Egyptian' = 'Egyptian',
  'Emirati' = 'Emirati',
  'English' = 'English',
  'Equatorial Guinean' = 'Equatorial Guinean',
  'Eritrean' = 'Eritrean',
  'Estonian' = 'Estonian',
  'Ethiopian' = 'Ethiopian',
  'Faroese' = 'Faroese',
  'Fijian' = 'Fijian',
  'Filipino' = 'Filipino',
  'Finnish' = 'Finnish',
  'French' = 'French',
  'Gabonese' = 'Gabonese',
  'Gambian' = 'Gambian',
  'Georgian' = 'Georgian',
  'German' = 'German',
  'Ghanaian' = 'Ghanaian',
  'Gibraltarian' = 'Gibraltarian',
  'Greek' = 'Greek',
  'Greenlandic' = 'Greenlandic',
  'Grenadian' = 'Grenadian',
  'Guamanian' = 'Guamanian',
  'Guatemalan' = 'Guatemalan',
  'Guinean' = 'Guinean',
  'Guyanese' = 'Guyanese',
  'Haitian' = 'Haitian',
  'Honduran' = 'Honduran',
  'Hong Konger' = 'Hong Konger',
  'Hungarian' = 'Hungarian',
  'Icelandic' = 'Icelandic',
  'Indian' = 'Indian',
  'Indonesian' = 'Indonesian',
  'Iranian' = 'Iranian',
  'Iraqi' = 'Iraqi',
  'Irish' = 'Irish',
  'Israeli' = 'Israeli',
  'Italian' = 'Italian',
  'Ivorian' = 'Ivorian',
  'Jamaican' = 'Jamaican',
  'Japanese' = 'Japanese',
  'Jordanian' = 'Jordanian',
  'Kazakh' = 'Kazakh',
  'Kenyan' = 'Kenyan',
  'Kittitian' = 'Kittitian',
  'Kosovan' = 'Kosovan',
  'Kuwaiti' = 'Kuwaiti',
  'Kyrgyz' = 'Kyrgyz',
  'Lao' = 'Lao',
  'Latvian' = 'Latvian',
  'Lebanese' = 'Lebanese',
  'Liberian' = 'Liberian',
  'Libyan' = 'Libyan',
  'Liechtenstein citizen' = 'Liechtenstein citizen',
  'Lithuanian' = 'Lithuanian',
  'Luxembourger' = 'Luxembourger',
  'Macanese' = 'Macanese',
  'Macedonian' = 'Macedonian',
  'Malagasy' = 'Malagasy',
  'Malawian' = 'Malawian',
  'Malaysian' = 'Malaysian',
  'Maldivian' = 'Maldivian',
  'Malian' = 'Malian',
  'Maltese' = 'Maltese',
  'Marshallese' = 'Marshallese',
  'Martiniquais' = 'Martiniquais',
  'Mauritanian' = 'Mauritanian',
  'Mauritian' = 'Mauritian',
  'Mexican' = 'Mexican',
  'Micronesian' = 'Micronesian',
  'Moldovan' = 'Moldovan',
  'Monegasque' = 'Monegasque',
  'Mongolian' = 'Mongolian',
  'Montenegrin' = 'Montenegrin',
  'Montserratian' = 'Montserratian',
  'Moroccan' = 'Moroccan',
  'Mosotho' = 'Mosotho',
  'Mozambican' = 'Mozambican',
  'Namibian' = 'Namibian',
  'Nauruan' = 'Nauruan',
  'Nepalese' = 'Nepalese',
  'New Zealander' = 'New Zealander',
  'Nicaraguan' = 'Nicaraguan',
  'Nigerian' = 'Nigerian',
  'Nigerien' = 'Nigerien',
  'Niuean' = 'Niuean',
  'North Korean' = 'North Korean',
  'Northern Irish' = 'Northern Irish',
  'Norwegian' = 'Norwegian',
  'Omani' = 'Omani',
  'Pakistani' = 'Pakistani',
  'Palauan' = 'Palauan',
  'Palestinian' = 'Palestinian',
  'Panamanian' = 'Panamanian',
  'Papua New Guinean' = 'Papua New Guinean',
  'Paraguayan' = 'Paraguayan',
  'Peruvian' = 'Peruvian',
  'Pitcairn Islander' = 'Pitcairn Islander',
  'Polish' = 'Polish',
  'Portuguese' = 'Portuguese',
  'Prydeinig' = 'Prydeinig',
  'Puerto Rican' = 'Puerto Rican',
  'Qatari' = 'Qatari',
  'Romanian' = 'Romanian',
  'Russian' = 'Russian',
  'Rwandan' = 'Rwandan',
  'Salvadorean' = 'Salvadorean',
  'Sammarinese' = 'Sammarinese',
  'Samoan' = 'Samoan',
  'Sao Tomean' = 'Sao Tomean',
  'Saudi Arabian' = 'Saudi Arabian',
  'Scottish' = 'Scottish',
  'Senegalese' = 'Senegalese',
  'Serbian' = 'Serbian',
  'Sierra Leonean' = 'Sierra Leonean',
  'Singaporean' = 'Singaporean',
  'Slovak' = 'Slovak',
  'Slovenian' = 'Slovenian',
  'Solomon Islander' = 'Solomon Islander',
  'Somali' = 'Somali',
  'South African' = 'South African',
  'South Korean' = 'South Korean',
  'South Sudanese' = 'South Sudanese',
  'Spanish' = 'Spanish',
  'Sri Lankan' = 'Sri Lankan',
  'St Helenian' = 'St Helenian',
  'St Lucian' = 'St Lucian',
  'Stateless' = 'Stateless',
  'Sudanese' = 'Sudanese',
  'Surinamese' = 'Surinamese',
  'Swazi' = 'Swazi',
  'Swedish' = 'Swedish',
  'Swiss' = 'Swiss',
  'Syrian' = 'Syrian',
  'Taiwanese' = 'Taiwanese',
  'Tajik' = 'Tajik',
  'Tanzanian' = 'Tanzanian',
  'Thai' = 'Thai',
  'Togolese' = 'Togolese',
  'Tongan' = 'Tongan',
  'Trinidadian' = 'Trinidadian',
  'Tristanian' = 'Tristanian',
  'Tunisian' = 'Tunisian',
  'Turkish' = 'Turkish',
  'Turkmen' = 'Turkmen',
  'Turks and Caicos Islander' = 'Turks and Caicos Islander',
  'Tuvaluan' = 'Tuvaluan',
  'Ugandan' = 'Ugandan',
  'Ukrainian' = 'Ukrainian',
  'Uruguayan' = 'Uruguayan',
  'Uzbek' = 'Uzbek',
  'Vatican citizen' = 'Vatican citizen',
  'Venezuelan' = 'Venezuelan',
  'Vietnamese' = 'Vietnamese',
  'Vincentian' = 'Vincentian',
  'Wallisian' = 'Wallisian',
  'Welsh' = 'Welsh',
  'Yemeni' = 'Yemeni',
  'Zambian' = 'Zambian',
  'Zimbabwean' = 'Zimbabwean',
}
